import { GridInputValue } from '../../../../types/types';

export const parseStringValue = (value: GridInputValue) =>
  value === null || value === undefined ? null : String(value);
